import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawOnImageComponent } from './draw-on-image.component';

@NgModule({
  declarations: [DrawOnImageComponent],
  imports: [
    CommonModule
  ],
  exports: [DrawOnImageComponent]
})
export class DrawOnImageModule { }
